import { Amplify } from "aws-amplify";
/**
 * Configure Amplify Auth with Cognito settings
 * Call this once at app startup before using any auth features
 */
export function configureAuth(config) {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: config.userPoolId,
                userPoolClientId: config.userPoolClientId,
                loginWith: {
                    oauth: {
                        domain: config.oauthDomain,
                        scopes: ["email", "openid", "profile"],
                        redirectSignIn: [config.redirectSignIn],
                        redirectSignOut: [config.redirectSignOut],
                        responseType: "code",
                        providers: ["Google", "Apple"],
                    },
                },
            },
        },
    });
}
//# sourceMappingURL=config.js.map